import {SimplePresentation, SimplePresentationRunnerController} from "../../../SimplePresentationRunner";
import {XwaysHoarder2} from "../../../XwaysHoarder2";
import {BasicSymbol, SymbolStates} from "../../../reels/symbols/BasicSymbol";
import {gsap} from "gsap";
import {XwaysHoarder2Sound} from "../../../sound/XwaysHoarder2Sound";
import {LTSymbol} from "../../../reels/symbols/LTSymbol";
import {ArrayHelper} from "@nolimitcity/slot-game/bin/utils/ArrayHelper";


export class LootRespinBeforeStart implements SimplePresentation {
    name: string = "lootRespinBeforeStart";

    shouldRun(): boolean {
        return XwaysHoarder2.model.isRespinStarting && !XwaysHoarder2.model.gameData.brokeTheBank;
    }

    start(controller: SimplePresentationRunnerController): void {
        const tl: gsap.core.Timeline = gsap.timeline({
            onComplete: () => {
                controller.setSkipCallback();
                controller.finish();
            }
        });

        let voice_n_music_idx: number = 0;
        let respinMusicName:  string = "";
        [0, 1, 2].forEach((sId, index: number) => {
            const sym: BasicSymbol = <BasicSymbol>XwaysHoarder2.reelView.reels[0].model.getVisibleSymbolAt(sId).positionable;
            if (sym) {
                if (sym.symbolName === "LT") {
                        if(!XwaysHoarder2.model.data.reSpinTriggeredByAnotherLoot) {
                            tl.add(() => {
                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.RESPIN_SYMBOL_EXPANSION);
                                XwaysHoarder2Sound.RESPIN_VOICE_N_MUSIC = ArrayHelper.shuffle(XwaysHoarder2Sound.RESPIN_VOICE_N_MUSIC);
                                voice_n_music_idx = (XwaysHoarder2Sound.RESPIN_VOICE_N_MUSIC[0][1] !== XwaysHoarder2Sound.LAST_RESPIN_MUSIC)? 0 : 1;
                                XwaysHoarder2Sound.LAST_RESPIN_MUSIC = respinMusicName = XwaysHoarder2Sound.RESPIN_VOICE_N_MUSIC[voice_n_music_idx][1];

                                XwaysHoarder2Sound.playTrack(XwaysHoarder2Sound.RESPIN_VOICE_N_MUSIC[voice_n_music_idx][0]);
                                //XwaysHoarder2Sound.fadeMusic(0, 100);
                                XwaysHoarder2Sound.fadeOutButDoNotStopMusic(XwaysHoarder2Sound.MAIN_GAME_MUSIC, 100);

                            }, 0)
                        }
                        tl.add((<LTSymbol>sym).getStateAnimation(SymbolStates.REVEAL),0);
                        if(!XwaysHoarder2.model.data.reSpinTriggeredByAnotherLoot) {
                            respinMusicName = XwaysHoarder2Sound.RESPIN_VOICE_N_MUSIC[voice_n_music_idx][1];

                            tl.add(() => {

                                if (XwaysHoarder2.apiPlugin.gameClientConfiguration.useCensoredSoundUS && respinMusicName.includes("3")) {
                                    respinMusicName = XwaysHoarder2Sound.RESPIN_MUSIC_US;
                                }
                                XwaysHoarder2Sound.fadeSpecificMusic(respinMusicName, 1, 2600);
                            }, 2.8);
                        }
                }
            }
        });


        XwaysHoarder2.model.data.reels.forEach((reel: string[], rId: number) => {
            reel.forEach((sym: string, sId: number) => {
                if (rId !== 0) {
                    const payingSym: BasicSymbol = <BasicSymbol>XwaysHoarder2.reelView.reels[rId].model.getVisibleSymbolAt(sId).positionable;
                    if (payingSym.symbolName.includes("L") || payingSym.symbolName.includes("M")) {
                        tl.add(payingSym.getStateAnimation(SymbolStates.NO_WIN), "<");
                    }
                }
            });
        });

        controller.setSkipCallback(() => {
            this.lootrevealSkip(tl)
        });
    }


    private lootrevealSkip(tl: gsap.core.Timeline): void {
        tl.totalProgress(1);
    }


}